exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bolt-portal-host {\n  position: fixed;\n  /* 1 million used because OF used it and the product has built around this number */\n  z-index: 1000000; }\n\n.bolt-portal {\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 10; }\n", ""]);

// exports
